<template>
  <div
    class="relative mx-auto flex max-w-[500px] flex-col items-center gap-8 overflow-hidden py-24 pb-60"
    data-testid="page-order-confirmation"
  >
    <div class="flex w-full flex-col items-center gap-4 text-center">
      <h1 class="txt-headline-m text-main">
        {{ t('FestivalShop.orderConfirmation.title') }}
      </h1>
      <p class="text-body-lg text-main">
        {{ t('FestivalShop.orderConfirmation.message') }}
      </p>
    </div>

    <Button class="btn-secondary-color-s" @click="viewOrder">
      {{ t('FestivalShop.orderConfirmation.viewOrder') }}
    </Button>

    <!-- Decorative illustration -->
    <div class="pointer-events-none inset-x-0 flex justify-center">
      <img :src="orderConfirmationIllustration" alt="" class="w-full max-w-[682px]" aria-hidden="true" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import orderConfirmationIllustration from './order-confirmation-illustration.svg'

const { t } = useI18n()
const router = useRouter()

const props = defineProps<{
  eventSlug: string
  kioskId: string
}>()

const viewOrder = () => {
  router.push({
    name: 'shopManageOrders',
    params: {
      eventSlug: props.eventSlug,
      kioskId: props.kioskId,
    },
  })
}
</script>
